/**
 * 商户模块路由
 * topNav: merchants
 */
export default {
  path: 'merchants',
  name: 'Merchants',
  component: () => import('@/layout/RouteView.vue'),
  meta: {
    title: '商户',
    titleKey: 'routes.merchants',
    topNav: 'merchants',
    icon: 'SettingOutlined',
  },
  children: [
    // 企业信息（直接页面）
    {
      path: 'company-info',
      name: 'CompanyInfo',
      component: () => import('@/views/merchants/company-info.vue'),
      meta: {
        title: '企业信息',
        titleKey: 'routes.companyInfo',
        permission: 'merchants:company-info',
      },
    },
    // 邮箱配置（直接页面）
    {
      path: 'email-config',
      name: 'EmailConfig',
      component: () => import('@/views/merchants/email-config.vue'),
      meta: {
        title: '邮箱配置',
        titleKey: 'routes.emailConfig',
        permission: 'merchants:email-config',
      },
    },
    // 短信配置（直接页面）
    {
      path: 'sms-config',
      name: 'SmsConfig',
      component: () => import('@/views/merchants/sms-config.vue'),
      meta: { title: '短信配置', titleKey: 'routes.smsConfig', permission: 'merchants:sms-config' },
    },
    // 多语言管理（直接页面）
    {
      path: 'i18n-management',
      name: 'I18nManagement',
      component: () => import('@/views/merchants/i18n-management.vue'),
      meta: {
        title: '多语言管理',
        titleKey: 'routes.i18nManagement',
        permission: 'merchants:i18n',
      },
    },
    // 售后反馈（直接页面）
    {
      path: 'after-sale-feedback',
      name: 'AfterSaleFeedback',
      component: () => import('@/views/merchants/after-sale-feedback.vue'),
      meta: {
        title: '售后反馈',
        titleKey: 'routes.afterSaleFeedback',
        permission: 'merchants:after-sale',
      },
    },
    // 系统设置（分组）
    {
      path: 'system-settings',
      name: 'SystemSettings',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '系统设置', titleKey: 'routes.systemSettings', icon: 'SettingOutlined' },
      children: [
        {
          path: 'role',
          name: 'RoleManagement',
          component: () => import('@/views/merchants/system-settings/role-management.vue'),
          meta: {
            title: '角色管理',
            titleKey: 'routes.roleManagement',
            permission: 'merchants:role',
          },
        },
        {
          path: 'account',
          name: 'AccountManagement',
          component: () => import('@/views/merchants/system-settings/account-management.vue'),
          meta: {
            title: '账号管理',
            titleKey: 'routes.accountManagement',
            permission: 'merchants:account',
          },
        },
        {
          path: 'operation-log',
          name: 'OperationLog',
          component: () => import('@/views/merchants/system-settings/operation-log.vue'),
          meta: {
            title: '操作日志',
            titleKey: 'routes.operationLog',
            permission: 'merchants:operation-log',
          },
        },
      ],
    },
  ],
};
